import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { ScreenOrientation as CapacitorScreenOrientation } from '@capacitor/screen-orientation';

@Injectable({
  providedIn: 'root',
})
export class ChartFullscreenService {
  async enterLandscape(): Promise<void> {
    // App rotation is globally disabled, so chart fullscreen must keep portrait.
    await this.enforcePortrait();
  }

  async exitLandscape(): Promise<void> {
    await this.enforcePortrait();
  }

  scheduleReflow(
    chart:
      | {
          reflow?: () => void;
          setSize?: (w?: number | null, h?: number | null, animate?: boolean) => void;
        }
      | null
      | undefined
  ): void {
    if (!chart) {
      return;
    }
    const apply = () => {
      if (chart.setSize) {
        chart.setSize(null, null, false);
      } else if (chart.reflow) {
        chart.reflow();
      }
    };
    // Orientation change animation needs a beat before Highcharts measures layout.
    setTimeout(apply, 100);
    setTimeout(apply, 400);
    setTimeout(apply, 800);
  }

  private canUseNativeOrientation(): boolean {
    return (
      Capacitor.isNativePlatform() &&
      Capacitor.isPluginAvailable('ScreenOrientation')
    );
  }

  private async enforcePortrait(): Promise<void> {
    try {
      if (this.canUseNativeOrientation()) {
        try {
          await CapacitorScreenOrientation.lock({ orientation: 'portrait' });
        } catch {
          // ignore
        }
        return;
      }

      const orientation = screen.orientation as {
        lock?: (o: OrientationLockType) => Promise<void>;
      };
      if (orientation?.lock) {
        try {
          await orientation.lock('portrait');
        } catch {
          // ignore
        }
      }
    } catch (err) {
      console.warn('[ChartFullscreen] Failed to enforce portrait', err);
    }
  }
}
